import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { SelectFieldMultiList } from 'shared/ui/Select/SelectMultiListField/SelectMultiListField'
import { MultiSelectDropdownContent } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/MultiSelectDropdownContent'
import type { TeamsSelectFieldStore } from 'pages/clients/ui/shared/TeamsSelectField/store/teamsSelectFieldStore'
import styles from './styles.module.scss'

type ITeamsSelectFieldProps = {
  store: TeamsSelectFieldStore
  disabled?: boolean
  width?: number
  labelText?: string
  placeholderClassName?: string
}

export const TeamsSelectField = observer(
  ({
    store,
    labelText = 'Teams',
    disabled,
    width = 436,
    placeholderClassName,
  }: ITeamsSelectFieldProps) => {
    const { teamsList, selectedItems, addTeam, removeTeam } = store
    return (
      <SelectFieldMultiList
        withInitialSearch
        initialSearchPlaceholder='Select'
        labelText={labelText}
        items={teamsList}
        selectedItems={selectedItems}
        onSelect={addTeam}
        onDelete={removeTeam}
        maxVisibleChips={9}
        maxChipsHeight={224}
        placeholderClassName={classNames(styles.teamsSelectPlaceholder, placeholderClassName)}
        dropdownProps={{
          disabled,
          width,
          PopperProps: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  offset: ({ reference }) => {
                    return [-2, -reference.height - 8]
                  },
                },
              },
            ],
          },
        }}
        customComponent={() => (
          <MultiSelectDropdownContent
            items={teamsList}
            selectedItems={selectedItems}
            onSelect={addTeam}
            onDelete={removeTeam}
            placeholder='Search teams'
            notFoundText='No teams found'
            shouldShowNotFoundText
            scrollBarMaxHeight={200}
          />
        )}
      />
    )
  }
)
